import { useForm } from "react-hook-form";

import { useConfirmDialogExit } from "hooks";
import { SingleStepBody, SingleStepDialog } from "components/SingleStepDialog";
import {
  errorPassword,
  formDeleteAccount,
  inputPassword,
  modalDeleteAccount,
  modalDeleteAccountSubtitlePart1,
  modalDeleteAccountSubtitlePart2,
} from "_constants";

import { useState } from "react";
import { PasswordInput } from "../../shared/inputs";
import { Divider } from "primereact/divider";
import { PrimeIcons } from "primereact/api";
import { ModalDeleteAccountLoading } from "./components/ModalDeleteAccountLoading";
import { deleteAccount } from "services";
import { useNavigate } from "react-router-dom";
import { deleteTokensFromStorage } from "utils";
import { FooterDeleteAccount } from "./components/FooterDeleteAccount";

export const ModalDeleteAccount = ({
  showModal,
  onClose,
}: {
  showModal: boolean;
  onClose: Function;
}) => {
  const navigate = useNavigate();
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const { showConfirmDialogExit } = useConfirmDialogExit();
  const [showModalLoading, setShowModalLoading] = useState(false);

  const { handleSubmit, control } = useForm({
    defaultValues: {
      password: "",
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    control._reset();
    onClose();
  };

  const onSubmit = (formData: any) => {
    setShowModalLoading(true);
    setTimeout(() => {
      deleteAccount(formData)
        .then((_) => {
          resetFormState();
          deleteTokensFromStorage();
          navigate("/");
        })
        .catch((error) => {
          if (error.status === 403) {
            setIsPasswordValid(false);
          }
        })
        .finally(() => setShowModalLoading(false));
    }, 1000);
  };

  return (
    <>
      <SingleStepDialog
        onHideCallback={handleDismiss}
        height="354px"
        width="450px"
        header={<></>}
        body={
          <SingleStepBody
            content={
              <div className="flex-container column width-100 align-center">
                <span
                  className={`${PrimeIcons.TRASH} confirm-dialog-icon danger padd-14 w-56 h-56 margin-bottom-24`}
                ></span>
                <h4 className="header-title margin-bottom-4">
                  {modalDeleteAccount}
                </h4>
                <span className="text-base-regular">
                  {modalDeleteAccountSubtitlePart1}
                </span>
                <span className="text-base-regular">
                  {modalDeleteAccountSubtitlePart2}
                </span>
                <form
                  id={formDeleteAccount}
                  onSubmit={handleSubmit(onSubmit)}
                  className="width-100 margin-bottom-12"
                >
                  <div className="width-100 margin-top-24">
                    <PasswordInput
                      control={control}
                      name="password"
                      placeholder={inputPassword}
                      onFocusCallback={() => setIsPasswordValid(true)}
                    />
                    {!isPasswordValid && (
                      <small className="p-error">{errorPassword}</small>
                    )}
                  </div>
                </form>
                <Divider className="margin-top-0 margin-bottom-0" />
              </div>
            }
          />
        }
        footer={<FooterDeleteAccount handleDismiss={handleDismiss} />}
        display={showModal}
        setVisible={() => {}}
      />
      <ModalDeleteAccountLoading showModal={showModalLoading} />
    </>
  );
};
